import {Button, ButtonGroup, closeCurrentDialog} from 'platform/components';
import {Box, Center, Heading, HStack, Icon, Text, VStack} from 'platform/foundation';
import {useFormatNumber} from 'platform/locale';

import {Trans} from 'react-i18next';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId, valueOrPlaceholder} from 'shared/web';

export interface CarPassSubmitSuccessDialogProps extends RequiredTestIdProps {
  vehicleTitle: string | undefined;
  mileage: number | null;
}

export function CarPassSubmitSuccessContent(props: CarPassSubmitSuccessDialogProps) {
  const formatNumber = useFormatNumber();

  return (
    <VStack spacing={4} align="center">
      <Center>
        <Box padding={3} borderRadius="circular" backgroundColor="palettes.green.20.100">
          <Icon value="action/check_circle" size={8} color="severity.success" />
        </Box>
      </Center>

      <Heading size={4} align="center">
        {i18n.t('page.carPass.labels.successTitle')}
      </Heading>

      <Text align="center">
        <Trans
          i18nKey="page.carPass.labels.successBody"
          components={{bold: <strong />}}
          values={{
            vehicleName: valueOrPlaceholder(props.vehicleTitle),
            mileage: valueOrPlaceholder(formatNumber(props.mileage)),
          }}
        />
      </Text>

      <HStack spacing={2} align="center" justify="center">
        <Box
          padding={1}
          paddingHorizontal={3}
          borderRadius="circular"
          backgroundColor="palettes.green.20.100"
        >
          <HStack spacing={2} align="center">
            <Icon value="action/schedule" size={3} color="severity.success" />
            <Text size="xSmall" color="success" alternative>
              {i18n.t('page.carPass.labels.successStatusPill')}
            </Text>
          </HStack>
        </Box>
      </HStack>

      <Text align="center" size="xSmall" color="secondary">
        {i18n.t('page.carPass.information.successHint')}
      </Text>

      <ButtonGroup align="center">
        <Button
          variant="primary"
          title={i18n.t('page.carPass.actions.close')}
          onClick={closeCurrentDialog}
          data-testid={suffixTestId('close', props)}
        />
      </ButtonGroup>
    </VStack>
  );
}
